import React from 'react';

const Blog = () => {
    return (
        <div name="blog"
        className="w-full h-screen bg-[#0a192f] text-white text-center mt-16">
             <p className='text-4xl font-bold inline border-b-4 border-pink-600  text-gray-300'>Blog</p>
             <h1 className='text-6xl text-center mt-32 text-orange-500  font-extrabold'>Coming Soon...</h1>
        </div>
    );
};

export default Blog;